export default "__VITE_ASSET__DE02PHyD__"